import * as Sentry from '@sentry/react'

import { getCurrentEnv } from 'helpers/getCurrentEnv'

import { CurrentEnvironment } from 'root-constants'

export const TRACKED_ENVIRONMENTS = [CurrentEnvironment.PROD]
const WEB_VITALS_TRACES_SAMPLE_RATE_BY_ENV = {
  [CurrentEnvironment.PROD]: 0.01,
  [CurrentEnvironment.STAGE]: 0.1,
}

export const initSentry = (): void => {
  try {
    const environment = getCurrentEnv()

    if (
      !process.env.SENTRY_DSN ||
      !TRACKED_ENVIRONMENTS.includes(environment)
    ) {
      return
    }

    Sentry.init({
      dsn: process.env.SENTRY_DSN,
      environment,
      release: process.env.SENTRY_RELEASE,
      tracesSampleRate: WEB_VITALS_TRACES_SAMPLE_RATE_BY_ENV[environment] || 0,
      sampleRate: 0.3,
      sendDefaultPii: false,
      enhanceFetchErrorMessages: false,
      defaultIntegrations: [
        Sentry.eventFiltersIntegration(),
        Sentry.breadcrumbsIntegration({
          console: false,
          dom: false,
          fetch: false,
          history: true,
          sentry: true,
          xhr: false,
        }),
        Sentry.globalHandlersIntegration(),
        Sentry.linkedErrorsIntegration(),
        Sentry.dedupeIntegration(),
      ],
      integrations: [
        Sentry.browserTracingIntegration({
          instrumentPageLoad: true,
          instrumentNavigation: false,
          traceFetch: false,
          traceXHR: false,
          enableHTTPTimings: false,
          enableLongTask: false,
          enableLongAnimationFrame: false,
          ignoreResourceSpans: [
            'resource.script',
            'resource.css',
            'resource.img',
            'resource.other',
          ],
          ignorePerformanceApiSpans: [/.*/],
          linkPreviousTrace: 'off',
        }),
      ],
      ignoreErrors: [
        'top.GLOBALS',
        'originalCreateNotification',
        'canvas.contentDocument',
        'MyApp_RemoveAllHighlights',
        'jigsaw is not defined',
        'ComboSearch is not defined',
        'http://loading.retry.widdit.com/',
        'atomicFindClose',
        'fb_xd_fragment',
        'bmi_SafeAddOnload',
        'EBCallBackMessageReceived',
        'conduitPage',
        'Script error.',
        '_avast_submit',
        'withrealtime/messaging',
        /gtag/,
        /illegal/,
        'Failed to fetch',
        'NetworkError when attempting to fetch resource',
        'Load failed',
        'AbortError',
        'The operation was aborted',
        'Java object is gone',
        'Error invoking postMessage',
        /^Network Error$/,
        'window.webkit.messageHandlers',
        'window.clarity is not a function',
      ],
      beforeSend(event) {
        if (event.exception || event.message) return event
        return null
      },
    })
  } catch (error) {
    console.warn('initSentry failed', error)
  }
}
